import { cx } from "@frontend/components/ui";
import type { ReliabilityTone } from "@frontend/lib/reliability";

const TONE: Record<ReliabilityTone, string> = {
  green: "bg-money-50 text-money-700 ring-money-100",
  amber: "bg-warn-50 text-warn-700 ring-warn-100",
  red: "bg-alert-50 text-alert-600 ring-alert-100",
  neutral: "bg-canvas text-ink-muted ring-line",
};

/** Compact counterpart score (out of 10) shown next to a name. */
export function TrackScoreBadge({
  value,
  tone,
  title,
}: {
  value: string;
  tone: ReliabilityTone;
  title?: string;
}) {
  return (
    <span
      title={title}
      className={cx(
        "tabular inline-flex h-4 shrink-0 items-center rounded px-1 text-[10px] font-semibold leading-none ring-1",
        TONE[tone],
      )}
    >
      {value}
    </span>
  );
}
